import { render, staticRenderFns } from "./NewsVisor.vue?vue&type=template&id=2c7920b8"
import script from "./NewsVisor.vue?vue&type=script&lang=js"
export * from "./NewsVisor.vue?vue&type=script&lang=js"
import style0 from "./NewsVisor.vue?vue&type=style&index=0&id=2c7920b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports